import React from 'react';
import { Shield } from 'lucide-react';

const SecuritySettings: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="rounded-2xl bg-gradient-to-br from-red-500 to-pink-600 p-3">
          <Shield className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Security Settings</h1>
          <p className="text-gray-600">Manage your account security and authentication</p>
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
        <p className="text-gray-600">Security settings content will be implemented here.</p>
      </div>
    </div>
  );
};

export default SecuritySettings;
